import React, { useEffect } from 'react';

const Framework = ({language, frameworkSetting, setFramework, languages}) => {

    useEffect(()=>{
        setFramework({...frameworkSetting, framework_type: "Flask"})
    },[])

    useEffect(()=>{
        languages.map((lang => {
            if (language === lang.name){
            setFramework({...frameworkSetting, framework_type: lang.frameworkOptions[0].value})
        }
        }))
    },[language])

    return (
        <div>
            {languages.map(languageInfo => {
                if (language === languageInfo.name){
                    return <div className='info-block'>
                    <label>Framework:</label>
                    <select onChange={(e)=>{setFramework({...frameworkSetting, framework_type: e.target.value})}}>
                        {languageInfo.frameworkOptions.map(frameworkOption=>{return <option value={frameworkOption.value}>{frameworkOption.name}</option>})}
                    </select>
                </div>
                }
                
            })}
        </div>
    );
};

export default Framework;